import React             from "react";
import PropTypes         from 'prop-types';
import List              from "@material-ui/core/List/List";
import Divider           from "@material-ui/core/Divider/Divider";
import {findRoute}       from "../Drawer/router";
import {
    Drawer,
    DrawerItem,
    CaptionItem,
    BackItem,
}                        from '../Drawer';
import {withStyles}      from "@material-ui/core";
import {cloneDeep, omit} from "lodash";

class Navigation extends React.Component {

    static propTypes = {
        items: PropTypes.array.isRequired,
    };

    state = this.tryRestoreState();

    tryRestoreState() {
        let history = [null];

        // Build route history trace.
        findRoute(this.props.items,
            route => history.splice(1, 0, route)
        );

        // Restore state or return default.
        const context = history.pop();
        return {
            context,
            history,
            items: context ? context.items : this.props.items,
        };
    }

    handleSwitchContext(newContext) {
        let {context, history, items} = this.state;

        // Manage history.
        if (newContext) {
            // Push to history.
            history.push(context);
        } else {
            // Navigate back.
            newContext = history.pop();
        }

        // Set new items by context.
        if (newContext) {
            // Add items from context.
            items = newContext.items;
        } else {
            // Reset items to default.
            items = this.props.items;
        }

        this.setState({
            context: newContext,
            history,
            items,
        });
    }

    renderCaption(context) {
        return (
            <React.Fragment>
                <BackItem
                    onClick={this.handleSwitchContext.bind(this, null)}
                />

                <CaptionItem
                    className={context.class}
                    icon={context.icon}
                    iconCode={context.iconCode}
                    text={context.text}
                    subtitle={context.subtitle}
                />
            </React.Fragment>
        );
    }

    renderItem(item) {
        const classes = this.props.classes;

        if (item.divider) {
            // Render a divider.
            return (
                <Divider key={item.text}/>
            );
        } else if (item.items) {
            // Render a node item.
            return (
                <DrawerItem
                    onClick={this.handleSwitchContext.bind(this, item)}
                    onMouseUp={this.props.houseId && this.props.houseId.bind(this, item.id)}
                    accessoryIcon="chevron_right"
                    key={item.text}
                    text={item.text}
                    subtitle={item.subtitle}
                    icon={item.icon}
                    iconCode={item.iconCode}
                    className={item.class}
                    dusk='house-button'
                />
            );
        } else {
            // console.log(item);
            // Render a default item.
            return (
                <DrawerItem
                    component="a"
                    key={item.text}
                    text={item.text}
                    subtitle={item.subtitle}
                    icon={item.icon}
                    iconCode={item.iconCode}
                    href={item.href}
                    exact={item.exact}
                    className={item.class}
                    strict
                />
            );
        }
    }

    render() {
        const {context, items}   = this.state;
        const {allowBottomItems} = this.props.classes;
        const drawerProps        = omit(cloneDeep(this.props), 'classes.allowBottomItems'); // copy, not reference

        return (
            <Drawer {...drawerProps}>
                {context && (
                    this.renderCaption(context)
                )}

                <List component="nav" className={allowBottomItems}>
                    {items.map(
                        item => this.renderItem(item)
                    )}
                </List>
            </Drawer>
        );
    };
}

const styles = theme => {
    // console.log(theme);
    return ({
        allowBottomItems: {
            display      : 'flex',
            flexDirection: 'column',
            flexGrow     : 1
        },
    });
};

export default withStyles(styles)(Navigation);
